import { adminLogin, adminList } from '@/api/admin'
import { apiAdminToUi } from '@/api/adapters'
import { passwordToMd5 } from '@/utils/password'
import { connectMqtt, disconnectMqtt } from '@/services/mqttService'
import { resetSharedResource } from '@/services/dataService'

const LOGIN_KEY = 'sys_login_ok'

function syncMqttSession({ token, user, active }) {
  if (active && token && user && user.id) {
    connectMqtt({ adminId: user.id, token })
  } else {
    disconnectMqtt()
  }
}

export default {
  namespaced: true,
  state: {
    token: null,
    user: null,
    sessionActive: false
  },
  getters: {
    isAuthenticated(state) {
      return !!(state.sessionActive && state.token && state.user)
    }
  },
  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token
      state.user = user
    },
    SET_SESSION_ACTIVE(state, active) {
      state.sessionActive = !!active
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.user = null
      state.sessionActive = false
      disconnectMqtt()
    }
  },
  actions: {
    // passwordEncrypted=true 表示 password 已是加密后的 md5（单点登录场景），原文传输不再二次加密
    login({ commit }, { username, password, passwordEncrypted = false }) {
      return adminLogin({
        account: username.trim(),
        password_md5: passwordEncrypted ? password : passwordToMd5(password)
      }).then(res => {
        const d = res.data
        const user = apiAdminToUi(d)
        const token = d.token
        resetSharedResource()
        localStorage.setItem(LOGIN_KEY, JSON.stringify({ token, user }))
        sessionStorage.removeItem(LOGIN_KEY)
        commit('SET_AUTH', { token, user })
        commit('SET_SESSION_ACTIVE', true)
        syncMqttSession({ token, user, active: true })
        return user
      })
    },
    restore({ commit }) {
      const raw = localStorage.getItem(LOGIN_KEY) || sessionStorage.getItem(LOGIN_KEY)
      if (!raw) return Promise.resolve(false)
      try {
        const { token, user } = JSON.parse(raw)
        commit('SET_AUTH', { token, user })
        return adminList({ page: 1, page_size: 1 }, { silent: true })
          .then(() => {
            commit('SET_SESSION_ACTIVE', true)
            syncMqttSession({ token, user, active: true })
            return true
          })
          .catch(err => {
            if (err && Number(err.code) === 401) {
              localStorage.removeItem(LOGIN_KEY)
              sessionStorage.removeItem(LOGIN_KEY)
              resetSharedResource()
              commit('CLEAR_AUTH')
            } else {
              commit('SET_SESSION_ACTIVE', false)
            }
            return false
          })
      } catch (e) {
        localStorage.removeItem(LOGIN_KEY)
        sessionStorage.removeItem(LOGIN_KEY)
        commit('CLEAR_AUTH')
        return Promise.resolve(false)
      }
    },
    logout({ commit }) {
      disconnectMqtt()
      resetSharedResource()
      localStorage.removeItem(LOGIN_KEY)
      sessionStorage.removeItem(LOGIN_KEY)
      commit('CLEAR_AUTH')
    }
  }
}
